module.exports = __webpack_public_path__ + "img/site_privilege.a440c041.svg";